import React,{Fragment, useState} from 'react';
import PropTypes from 'prop-types';
import Error from './Error';


const Pregunta = ({guardarPresupuesto,guardarRestante, actualizarPregunta}) => {

  //DEFINIR EL STATE, CANTIDAD Y ERROR
  //como es una cantidad el useState lo definimos en 0.
  const [cantidad, guardarCantidad] = useState(0)
  const[error, guardarError] = useState(false)
  
  //Funcion que lee el presupuesto
  //el e es para tener acceso a los value
  const definirPresupuesto = e => {
    guardarCantidad(parseInt(e.target.value, 10)) //Convertir a un numero, y que sea un minimo de 10

  }
  //submit para definir el presupuesto
   const agregarPresupuesto = e =>{
      e.preventDefault();

      //validar
      if(cantidad < 1 || isNaN(cantidad)){
         guardarError(true);
         return;
      }

      //si se pasa la validacion
      guardarError(false);
      guardarPresupuesto(cantidad);
      guardarRestante(cantidad);
      actualizarPregunta(false);

   }

    return ( 
        <Fragment>
        <h2>Coloca tu presupuesto</h2>
        {error ? <Error mensaje="El Presupuesto es Incorrecto"/> : null}
  
        <form
         onSubmit = {agregarPresupuesto}
        >
          <input 
             type= "number"
             className= "u-full-width"
             placeholder="Coloca tu presupuesto"
             onChange={definirPresupuesto} //se ejecuta cuando el usuario este definiendo su presupuesto

           />
           <input
            type = "submit"
            className = "button-primary u-full-width"
            value = "Definir Presupuesto"
           />
        </form>
      
        </Fragment>
     );
}
 Pregunta.propTypes = {
   guardarPresupuesto: PropTypes.func.isRequired,
   guardarRestante: PropTypes.func.isRequired,
   actualizarPregunta: PropTypes.func.isRequired

 }
 
export default Pregunta ;